import { render, staticRenderFns } from "./SetScore.vue?vue&type=template&id=642ed4ae&scoped=true"
import script from "./SetScore.vue?vue&type=script&lang=js"
export * from "./SetScore.vue?vue&type=script&lang=js"
import style0 from "./SetScore.vue?vue&type=style&index=0&id=642ed4ae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ed4ae",
  null
  
)

export default component.exports